import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Row,
  Image,
  Modal,
  Button,
  ButtonGroup,
  Form,
} from "react-bootstrap";
import {
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  makeStyles,
  FormHelperText,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import SwitchMt from "@material-ui/core/Switch";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { Toggle } from "../../../../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import StickerQrComponent from "../../../../../../reusableComponents/QRCodePrintAndExport/StickerQrComponent";
import TableTentCardComponent from "../../../../../../reusableComponents/QRCodePrintAndExport/TableTentCardComponent";
import BasicPagination from "../../../../../../Pagination/Pagination";

import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import isEmpty from "../../../../../../../store/validation/is-Empty";
import { filterQrTableData } from "../../../../../../../store/actions/onboardingAction";
import ReactToPrint from "react-to-print";
import PrintSecondComponentQrCode from "./PrintSecondComponentQrCode";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
    marginBottom: "1rem",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const validate = (values) => {
  const errors = {};
  if (values.selectedFloor === "") {
    errors.selectedFloor = "Please Select Floor";
  } else if (
    values.selectFloorFrom === "" &&
    values.selectFloorTo === "" &&
    values.all === false
  ) {
    errors.selectFloorFrom = "Please Select Table From";
    errors.selectFloorTo = "Please Select Table From";
  }
  return errors;
};

const MultipleQrCodePrintByMerchant = (props) => {
  const componentRef = useRef();

  /********************************
   * @DESC Authentication Data
   *******************************/
  const authInfo = useSelector((state) => {
    return !isEmpty(state?.auth) ? state?.auth?.user : "";
  });

  let token = authInfo?.accessToken;
  let vendor_id = authInfo?.VendorUser?._id;
  let adminVendorId = props.adminVendorId;
  let finalVendorId =
    props.actionBy === "SUPERADMIN" ? adminVendorId : vendor_id;

  /************************************
   * @DESC Restaurant Onboarding Data
   ************************************/
  const restaurantInfo = useSelector((state) => {
    return !isEmpty(state?.onboarding)
      ? state?.onboarding?.restaurantDetails
      : "";
  });

  const [totalRecords, setTotalRecords] = useState("");
  const [totalLimit, setTotalLimit] = useState("");
  const [totalPages, setTotalPages] = useState("");

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [qrCodeTypeProps, setQrCodeType] = useState(props?.qrFrom);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [tableSeatFilteredData, setTableSeatFilteredData] = useState([]);
  const [selectFloorArr, setSelectFloorArr] = useState([]);
  const [selectFloorFromArr, setSelectFloorFromArr] = useState([]);
  const [finalQrCodeArr, setFinalQrCodeArr] = useState([]);
  const [selectAllToggleArr, setSelectAllToggleArr] = useState([]);
  const [selectQrType, setQrCodeTypeArr] = useState([
    { name: "Sticker", title: "Sticker" },
    { name: "TableTentCard", title: "Table Tent Card" },
  ]);
  const [selectPaperSize, setSelectedPaperSize] = useState([
    { name: "A4 (11.69 x 8.26 in)", title: "A4 (11.69 x 8.26 in)" },
  ]);

  ////////// @DESC Dispaly QR Code Preview
  const [displayPreview, setDisplayPreview] = useState(false);

  /*********************************
   * @DESC Open and Closed Action
   ********************************/
  const openModalQrPrint = () => {
    setOpen(true);
    formik.resetForm();
  };
  const closedModalQrPrint = () => {
    setOpen(false);
    formik.resetForm();
  };

  /*******************************
   * @DESC Set Data in State
   ******************************/
  const formik = useFormik({
    initialValues: {
      vendor_id: authInfo?.VendorUser?._id,
      restaurant_id: restaurantInfo?._id,
      selectedFloor: "",
      selectFloorFrom: "",
      selectFloorFromIndex: "",
      selectFloorTo: "",
      selectFloorToIndex: "",
      selectAllFloor: false,
      qrCodeType: "",
      qrCodeSize: 96,
      all: false,
      paperSize: "",
    },
    validationSchema: yup.object({
      // selectedFloor: yup.string().required("Please Select Floor"),
      qrCodeType: yup.string().required("Please Select QR Code Type"),
      qrCodeSize: yup.string().required("Please Select QR Code Size"),
      paperSize: yup.string().required("Please Select Paper Size"),
    }),
    validate,

    onSubmit: (values) => {
      onClickCheckTableStatus(values);
    },
  });

  const onClickNext = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  const onClickCheckTableStatus = (data) => {
    if (
      parseInt(data.selectFloorFromIndex) > parseInt(data.selectFloorToIndex)
    ) {
      formik.setErrors({
        selectFloorFrom:
          "Select Table From value is less than or equal to Select Table To value",
      });
    } else {
      let tableFrom = parseInt(data.selectFloorToIndex) + 1;
      let finalQrArr = selectFloorFromArr;
      let reDefineArray = finalQrArr
        .slice(data.selectFloorFromIndex, tableFrom)
        .map((i) => {
          return i._id;
        });
      let formData = {
        tables: !formik.values.all ? reDefineArray : selectAllToggleArr,
      };
      setLoading(true);
      dispatch(
        filterQrTableData(formData, finalVendorId, token, 6, page, onSuccess)
      );
      // setFinalQrCodeArr(reDefineArray);
      setDisplayPreview(true);
    }
  };

  const onSuccess = (data) => {
    setLoading(false);
  };

  /*************************************
   * @DESC SET FILTERED DATA First Load
   *************************************/
  useEffect(() => {
    setTableSeatFilteredData(props?.setQrTableData);
  }, [props?.setQrTableData]);

  /******** @DESC SET DATA IN SELECT FLOOR ARRAY *******/
  useEffect(() => {
    let blankArr = [];
    let allFloorArr = tableSeatFilteredData;
    let setObj = new Set();
    let result =
      allFloorArr &&
      allFloorArr.reduce((acc, item) => {
        if (!setObj.has(item.floor_number)) {
          setObj.add(item.floor_number, item);
          acc.push(item);
        }
        return acc;
      }, []);
    setSelectFloorArr(result);
    setFinalQrCodeArr(blankArr);
    setDisplayPreview(false);
  }, [tableSeatFilteredData && tableSeatFilteredData]);

  /******** @DESC SET DATA IN SELECTED FLOOR FROM TO ARRAY *******/
  useEffect(() => {
    let blankArr = [];
    let allFloorArr = tableSeatFilteredData;
    let filterArray = [];
    for (let i = 0; i <= allFloorArr.length; i++) {
      if (
        allFloorArr[i]?.floor_number === formik?.values?.selectedFloor &&
        allFloorArr[i]?.active === true
      ) {
        filterArray.push(allFloorArr[i]);
      }
    }
    setSelectFloorFromArr(filterArray);
    formik.setFieldValue("selectFloorFrom", "");
    formik.setFieldValue("selectFloorTo", "");
    setFinalQrCodeArr(blankArr);
    setDisplayPreview(false);
  }, [formik.values.selectedFloor]);

  /******** @DESC SET DATA IN FROM DROP DOWN *******/
  useEffect(() => {
    let blankArr = [];
    let allFloorArr = selectFloorFromArr;
    let fromTableIndex = allFloorArr
      .map((object) => object.table_number)
      .indexOf(formik.values.selectFloorFrom);
    formik.setFieldValue("selectFloorFromIndex", fromTableIndex);
    formik.setFieldValue("selectFloorTo", "");
    formik.setFieldValue("selectFloorToIndex", "");
    setDisplayPreview(false);
    setFinalQrCodeArr(blankArr);
    formik.setFieldValue("all", false);
    setSelectAllToggleArr(blankArr);
  }, [formik.values.selectFloorFrom]);

  /******** @DESC SET DATA IN To DROP DOWN *******/
  useEffect(() => {
    let blankArr = [];
    let allFloorArr = selectFloorFromArr;
    let fromTableIndex = allFloorArr
      .map((object) => object.table_number)
      .indexOf(formik.values.selectFloorTo);
    formik.setFieldValue("selectFloorToIndex", fromTableIndex);
    setDisplayPreview(false);
    setFinalQrCodeArr(blankArr);
    formik.setFieldValue("all", false);
    setSelectAllToggleArr(blankArr);
  }, [formik.values.selectFloorTo]);

  const onChangeToggle = () => {
    let blankArr = [];
    let data = selectFloorFromArr && selectFloorFromArr;
    let reDefineArray = data.map((i) => {
      return i._id;
    });
    if (formik.values.all) {
      formik.setFieldValue("all", !formik.values.all);
      setSelectAllToggleArr(blankArr);
      formik.setFieldValue("selectFloorFrom", "");
      formik.setFieldValue("selectFloorTo", "");
    } else {
      formik.setFieldValue("all", !formik.values.all);
      setSelectAllToggleArr(reDefineArray);
      formik.setFieldValue("selectFloorFrom", "");
      formik.setFieldValue("selectFloorTo", "");
    }
  };

  /************************************
   * @DESC Filter Table QR Code Data
   ************************************/
  const allQrCodeData = useSelector((state) => {
    return !isEmpty(state?.onboarding)
      ? state?.onboarding?.get_filter_table_data
      : "";
  });

  useEffect(() => {
    setFinalQrCodeArr(allQrCodeData?.data && allQrCodeData?.data);
    setTotalPages(allQrCodeData.total_pages && allQrCodeData.total_pages);
    setTotalRecords(allQrCodeData?.total && allQrCodeData?.total);
    setTotalLimit(allQrCodeData.per_page && allQrCodeData.per_page);
  }, [allQrCodeData]);

  const handleBatchChange = (pageNo) => {
    let tableFrom = parseInt(formik.values.selectFloorToIndex) + 1;
    let finalQrArr = selectFloorFromArr;
    let reDefineArray = finalQrArr
      .slice(formik.values.selectFloorFromIndex, tableFrom)
      .map((i) => {
        return i._id;
      });
    let formData = {
      tables: !formik.values.all ? reDefineArray : selectAllToggleArr,
    };
    setPage(pageNo);
    setLoading(true);
    dispatch(
      filterQrTableData(
        formData,
        finalVendorId,
        token,
        totalLimit,
        pageNo,
        onSuccess
      )
    );
  };

  const AntSwitch = withStyles((theme) => ({
    root: {
      width: 41,
      height: 15,
      padding: 0,
      display: "flex",
      overflow: "inherit",
    },
    switchBase: {
      padding: 2,
      color: "#212121",
      top: "-6px",
      left: "-5px",
      "&$checked": {
        transform: "translateX(20px)",
        color: "rgb(89, 248, 50)",
        "& + $track": {
          opacity: 1,
          backgroundColor: "rgb(238, 238, 238)",
          borderColor: "rgb(238, 238, 238)",
        },
      },
    },
    thumb: {
      width: 24,
      height: 24,
      boxShadow: "none",
    },
    track: {
      border: `1px solid rgb(238, 238, 238)`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "rgb(238, 238, 238)",
    },
    checked: {},
  }))(SwitchMt);

  return (
    <React.Fragment>
      {props.actionBy === "SUPERADMIN" ? (
        <button
          type="button"
          className="onboarding_button_link_reusable onboarding_button_link_reusable_red_outlined"
          onClick={openModalQrPrint}
        >
          Print Table QR Code
        </button>
      ) : (
        // <AddButtonIconComponent
        //   buttonText="Print Multiple"
        //   fontIcon="fa fa-print"
        //   colorCss="dark"
        //   onClick={openModalQrPrint}
        // />
        <button className="add-button-icon-reusable add-button-icon-reusable-dark">
          <Image
            src={require("../../../../../../../assets/images/tablemanagement/print_black.svg")}
            alt="print table"
            title="Print QR Code"
            style={{ width: "21%" }}
            onClick={openModalQrPrint}
          />
          <p className="ml-1">Print Multiple</p>
        </button>
      )}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        show={open}
        onHide={closedModalQrPrint}
        backdrop="static"
        centered
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div>
            <Modal.Title className="f20-700 pb-2">
              Print {props.qrFrom === "TABLE" ? "Table" : "Seat"} Range
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4 new-subscription-onboarding-component">
          <form noValidate onSubmit={(e) => onClickNext(e)}>
            <Row>
              <Col md={4} xs={12}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ marginBottom: "3px" }}
                >
                  <InputLabel htmlFor="outlined-time">Floor</InputLabel>
                  <Select
                    onChange={formik.handleChange}
                    value={formik.values.selectedFloor}
                    label="Floor"
                    inputProps={{
                      name: "selectedFloor",
                      id: "outlined-time",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="" disabled selected>
                      Select Table Floor
                    </MenuItem>
                    {selectFloorArr &&
                      selectFloorArr?.map((data, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={data.floor_number}
                            name={data.floor_number}
                          >
                            {data.floor_number}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                {formik.errors?.selectedFloor &&
                formik?.touched &&
                formik?.touched?.selectedFloor ? (
                  <div className="f14-500 text-danger">
                    {formik.errors?.selectedFloor}
                  </div>
                ) : (
                  <FormHelperText id="component-helper-text">
                    (Select Floor from Above)
                  </FormHelperText>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <h5 className="f12-500 mt-4 mb-2">Select Tables</h5>
              </Col>
              <Col md={4}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ marginBottom: "3px" }}
                >
                  <InputLabel htmlFor="outlined-time">From</InputLabel>
                  <Select
                    onChange={formik.handleChange}
                    value={formik.values.selectFloorFrom}
                    label="From"
                    inputProps={{
                      name: "selectFloorFrom",
                      id: "outlined-time",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="" disabled selected>
                      Select Table From
                    </MenuItem>
                    {selectFloorFromArr &&
                      selectFloorFromArr?.map((data, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={data.table_number}
                            name={data.table_number}
                          >
                            {data.table_number}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                {formik.errors?.selectFloorFrom &&
                formik?.touched &&
                formik?.touched?.selectFloorFrom ? (
                  <div className="f14-500 text-danger">
                    {formik.errors?.selectFloorFrom}
                  </div>
                ) : null}
              </Col>
              <Col md={4}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ marginBottom: "3px" }}
                >
                  <InputLabel htmlFor="outlined-time">To</InputLabel>
                  <Select
                    onChange={formik.handleChange}
                    value={formik.values.selectFloorTo}
                    label="To"
                    inputProps={{
                      name: "selectFloorTo",
                      id: "outlined-time",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="" disabled selected>
                      Select Table To
                    </MenuItem>
                    {selectFloorFromArr &&
                      selectFloorFromArr?.map((data, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={data.table_number}
                            name={data.table_number}
                          >
                            {data.table_number}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                {formik.errors?.selectFloorTo &&
                formik?.touched &&
                formik?.touched?.selectFloorTo ? (
                  <div className="f14-500 text-danger">
                    {formik.errors?.selectFloorTo}
                  </div>
                ) : null}
              </Col>
              <Col md={3} className="py-2">
                <div className="d-flex align-items-center">
                  <div className="f12-500 pr-2 mr-2 w-50">
                    Select all within the floor
                  </div>
                  <div>
                    <AntSwitch
                      checked={formik.values.all}
                      onChange={onChangeToggle}
                      name="all"
                      disabled={
                        formik.values.selectedFloor === "" ? true : false
                      }
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <h5 className="f12-500 mt-4 mb-2">QR Code Type</h5>
              </Col>
              <Col md={4}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ marginBottom: "3px" }}
                >
                  <InputLabel htmlFor="outlined-time">QR Code Type</InputLabel>
                  <Select
                    onChange={formik.handleChange}
                    value={formik.values.qrCodeType}
                    label="QR Code Type"
                    inputProps={{
                      name: "qrCodeType",
                      id: "outlined-time",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="" disabled selected>
                      Select Table QR Code Type
                    </MenuItem>
                    {selectQrType &&
                      selectQrType?.map((data, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={data.name}
                            name={data.name}
                          >
                            {data.title}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                {formik.errors?.qrCodeType &&
                formik?.touched &&
                formik?.touched?.qrCodeType ? (
                  <div className="f14-500 text-danger">
                    {formik.errors?.qrCodeType}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <h5 className="f12-500 mt-4 mb-2">QR Code Size</h5>
              </Col>
              <Col md={8} className="px-1">
                <ButtonGroup size="md" className="mb-1">
                  <Button
                    title="1 x 1 in Default Size"
                    variant="light"
                    className={`${
                      formik.values.qrCodeSize === 96
                        ? "qr_Code_sizeRed f11-700"
                        : "border-0 f11-500"
                    } bg-transparent`}
                    onClick={() => formik.setFieldValue("qrCodeSize", 96)}
                  >
                    1 x 1 in Default Size
                  </Button>
                  <Button
                    title="1.5 x 1.5 in"
                    variant="light"
                    className={`${
                      formik.values.qrCodeSize === 144
                        ? "qr_Code_sizeRed f11-700"
                        : "border-0 f11-500"
                    } bg-transparent`}
                    onClick={() => formik.setFieldValue("qrCodeSize", 144)}
                  >
                    1.5 x 1.5 in
                  </Button>
                  <Button
                    title="2 x 2 in"
                    variant="light"
                    className={`${
                      formik.values.qrCodeSize === 175
                        ? "qr_Code_sizeRed f11-700"
                        : "border-0 f11-500"
                    } bg-transparent`}
                    onClick={() => formik.setFieldValue("qrCodeSize", 175)}
                  >
                    2 x 2 in
                  </Button>
                </ButtonGroup>
                {formik.errors?.qrCodeSize &&
                formik?.touched &&
                formik?.touched?.qrCodeSize ? (
                  <div className="f14-500 text-danger">
                    {formik.errors?.qrCodeSize}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12} lg={12} className="py-2">
                <hr />
              </Col>
              <Col md={4}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ marginBottom: "3px" }}
                >
                  <InputLabel htmlFor="outlined-time">Paper Size</InputLabel>
                  <Select
                    onChange={formik.handleChange}
                    value={formik.values.paperSize}
                    label="Paper Size"
                    inputProps={{
                      name: "paperSize",
                      id: "outlined-time",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="" disabled selected>
                      Select Table Paper Size
                    </MenuItem>
                    {selectPaperSize &&
                      selectPaperSize?.map((data, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={data.name}
                            name={data.name}
                          >
                            {data.title}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                {formik.errors?.paperSize &&
                formik?.touched &&
                formik?.touched?.paperSize ? (
                  <div className="f14-500 text-danger">
                    {formik.errors?.paperSize}
                  </div>
                ) : null}
              </Col>
            </Row>
            {displayPreview ? (
              <></>
            ) : (
              <Row className="my-4">
                <Col sm={4} md={2}>
                  <Button
                    title="Cancel"
                    type="button"
                    variant="outline-secondary"
                    className="w-100"
                    style={{
                      borderRadius: 5,
                      fontWeight: 400,
                      fontSize: 12,
                      padding: 12,
                    }}
                    onClick={closedModalQrPrint}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col sm={4} md={2}>
                  <Button
                    title="Print Preview"
                    type="submit"
                    className="text-white w-100"
                    variant="danger"
                    style={{
                      borderRadius: 5,
                      fontWeight: 400,
                      fontSize: 12,
                      padding: 12,
                    }}
                  >
                    Print Preview
                  </Button>
                </Col>
              </Row>
            )}
          </form>
          {displayPreview ? (
            <Col
              md={12}
              style={{ maxHeight: 500, overflow: "scroll" }}
              id="style-4"
            >
              <Row>
                <h5 className="f11-500 mt-4 mb-2">Print Preview</h5>
              </Row>
              {loading ? (
                <>Loading...</>
              ) : (
                <div>
                  <PrintSecondComponentQrCode
                    onboarding={
                      props.actionBy === "SUPERADMIN"
                        ? props?.restaurantData
                        : restaurantInfo && restaurantInfo
                    }
                    setOpenPrintPreview={closedModalQrPrint}
                    qrData={finalQrCodeArr && finalQrCodeArr}
                    typeOfQr={qrCodeTypeProps === "TABLE" ? "table" : "seat"}
                    vendor_id={authInfo && authInfo?.VendorUser?._id}
                    formikValue={formik}
                    totalRecords={totalRecords}
                    totalLimit={totalLimit}
                    page={page}
                    handleBatchChange={(e) => handleBatchChange(e)}
                  />
                </div>
              )}
            </Col>
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default MultipleQrCodePrintByMerchant;

// const ComponentToPrint = (
//   componentRef,
//   finalQrCodeArr,
//   restaurantInfo,
//   authInfo,
//   formik,
//   qrCodeTypeProps
// ) => {
//   return (
//     <Row
//       className="border shadow-md bg-secondary rounded p-4"
//       style={{ maxHeight: 500, overflow: "scroll" }}
//       id="style-4"
//     >
//       {finalQrCodeArr.map((data, index) => {
//         let tableData = "";
//         let tableDataObject = {};
//         tableDataObject.restaurant_id = restaurantInfo?._id;
//         if (qrCodeTypeProps === "TABLE") {
//           tableDataObject.table_number = data?.table_number;
//         } else {
//           tableDataObject.seat_number = data?.seat_number;
//         }
//         tableDataObject.type =
//           qrCodeTypeProps === "TABLE"
//             ? "table_management"
//             : "seat_management";
//         tableDataObject.vendor_id = authInfo?.VendorUser?._id;
//         return formik.values?.qrCodeType === "Sticker" ? (
//           <Col md={4} className="mb-3" key={index}>
//             <StickerQrComponent
//               keysData={index}
//               qrData={tableDataObject}
//               sizeData={formik.values.qrCodeSize}
//               logo={restaurantInfo?.logo_url_thumbnails}
//               name={restaurantInfo?.restaurant_name}
//             />
//           </Col>
//         ) : (
//           <Col md={4} className="mb-3" key={index}>
//             <TableTentCardComponent
//               keysData={index}
//               qrData={tableDataObject}
//               sizeData={formik.values.qrCodeSize}
//               logo={restaurantInfo?.logo_url_thumbnails}
//               name={restaurantInfo?.restaurant_name}
//             />
//           </Col>
//         );
//       })}
//     </Row>
//   );
// };
